/*
 * @Author: guang
 * @Date: 2020-12-09 14:06:09
 * @LastEditTime: 2020-12-09 17:15:53
 * @LastEditors: lee
 * @Description:
 */

 export default {
    color: ["#FF7676", "#76B4FF"],
    tooltip: {
        trigger: "axis"
    },
    grid: {
        left: '5%',
        right: "14%",
        top: 0,
        bottom: 0,
        containLabel: true
    },
    xAxis: {
        type: 'value',
        position: "top",
        axisLine: {
            show: false
        },
        axisTick: {
            show: false
        },
        axisLabel: {
            show: true,
            color: "rgba(153, 153, 153, 1)",
            fontSize: "11"
        },
        boundaryGap: [0, 0.01]
    },
    yAxis: {
        type: "category",
        axisLine: {
            show: false
        },
        axisTick: {
            show: false
        },
        axisLabel: {
            show: true,
            color: "rgba(153, 153, 153, 1)",
            fontSize: "12"
        }
    },
    series: [{
        type: "bar",
        barWidth: 8,
        barGap: "100%",
        barCategoryGap: "50%",
        large: true,
        label: {
            show: true,
            position: "right",
            color: "rgba(51, 51, 51, 1)",
            fontSize: 11
        }
    }, {
        type: "bar",
        barWidth: 8,
        barGap: "100%",
        barCategoryGap: "50%",
        large: true,
        label: {
            show: true,
            position: "right",
            color: "rgba(51, 51, 51, 1)",
            fontSize: 11
        }
    }], // 动态生成seriesBar
    dataset: {
        dimensions: [],
        source: []
    }
}
